<template>
	<div>
		<div class="flex justify-center tabs font20">
			<div 
				class="tabs-item pointer" 
				v-for="item in loginMode" 
				:key="item.value" 
				:class="{'active': currentMode == item.value}"
				@click="handleChange(item)">{{ item.title }}</div>
		</div>
		<div class="form">
			<div class="form-item m-b-20">
				<el-input placeholder="手机号/账号" prefix-icon="el-icon-mobile" v-model="mobile"></el-input>
			</div>
			<div class="form-item m-b-20" v-if="currentMode == 1">
				<el-input 
					placeholder="密码" 
					type="password" 
					prefix-icon="el-icon-lock"
					v-model="password"
					@keyup.enter.native="handleSubmit"
				>
				</el-input>
			</div>
			<div class="flex form-item m-b-20" v-else>
				<el-input 
					placeholder="验证码" 
					prefix-icon="el-icon-key"
					v-model="captcha"
					@keyup.enter.native="handleSubmit"
				>
				</el-input>
				<el-button 
					class="m-l-10" 
					type="default" 
					:disabled="isDisable"
                    @click.stop.prevent="getCaptcha"
					>{{ 
						(!isDisable && "发送验证码") ||
                            countdownTime + "s后重新发送" 
					}}</el-button>
			</div>
			<div class="form-item m-b-20">
				<el-button class="login-btn" type="primary" @click="handleSubmit" :loading="isLoading">登录</el-button>
			</div>
			<div class="flex align-center form-item">
				<el-checkbox v-model="isAgree">
					<AgreeModal />
				</el-checkbox>
			</div>
		</div>
		<SlideVerify :isShow="showSlide" @close="showSlide = false" @success="handleSuccess" />
	</div>
</template>
<script>
import Md5 from 'js-md5'
import SlideVerify from '@/components/SlideVerify'
import AgreeModal from './components/AgreeModal.vue'
import { sendCaptcha, checkMobile } from "@/api/public"
const PHONE_REGEX = /^1[3456789]\d{9}$/
const loginModeList = [
	{
		title: '密码登录',
		value: 1
	}, {
		title: '验证码登录',
		value: 2
	}
]
export default {
	components: {
		AgreeModal,
		SlideVerify
	},
	data() {
		return {
			mobile: '',
			password: '',
			captcha: '',
			isAgree: true,
			countdownTime: 60,
			isDisable: false,
			isLoading: false,
			currentMode: 1,
			showSlide: false
		}
	},
	computed: {
		sysCfg() {
			return this.$store.getters.config
		},
		loginMode() {
			let list = this.sysCfg?this.sysCfg.webtool_login_mode : []
			if(list.length > 1) {
				return loginModeList
			} else if(list.length == 1) {
				return loginModeList.filter(item => item.value == list[0])
			} else {
				return [{...loginModeList[0]}]
			}
		},
		isSubAccount() {
			return !!(this.currentMode == 1 && this.mobile && this.mobile.includes(':'))
		}
	},
	mounted() {
		this.currentMode = this.sysCfg.webtool_login_mode[0]
	},
	methods: {
		handleChange(item) {
			if(item.value == this.currentMode) {
				return
			}
			this.currentMode = item.value
		},
		handleSuccess(v) {
			this.showSlide = false
			let mode = this.currentMode // 1 密码登录 2 验证码
			if(mode == 2) { // 验证码
				this.isDisable = true
				const interval = setInterval(() => {
					if (this.countdownTime-- <= 0) {
						this.countdownTime = 60
						this.isDisable = false
						clearInterval(interval)
					}
				}, 1000)
				sendCaptcha({
					iso: "cn",
					mobile: this.mobile,
					event: "mobilelogin",
				}).then((res) => {
					this.$message.success(res.msg)
				})
			} else { // 密码/子账号
				this.handleLogin()
			}
		},
		// 获取验证码
		getCaptcha() {
			if (!this.mobile || !PHONE_REGEX.test(this.mobile)) {
                this.$message.error("请输入格式正确的手机号")
                return
            }
			if (this.sysCfg && this.sysCfg.webtool_status === 0) { // 0 禁止登录
				return this.$message.error(this.sysCfg.webtool_close_msg || '系统维护暂不支持使用')
			}
			this.showSlide = true
		},
		handleSubmit() {
			if(this.isLoading) return
			if (!this.mobile) {
                this.$message.error("请输入手机号或子账号")
                return
            }
			if (this.currentMode == 1) {
				if (!this.isSubAccount && !PHONE_REGEX.test(this.mobile)) {
					this.$message.error("请输入格式正确的手机号")
					return
				}
				if (!this.password) {
					this.$message.error("请输入密码")
					return
				}
			}
            if (!this.captcha && this.currentMode == 2) {
                this.$message.error("请输入验证码")
                return
            }
			if (!this.isAgree) {
				return this.$message.error('请先阅读并同意《用户协议》与《隐私协议》')
			}
			if (this.sysCfg && this.sysCfg.webtool_status === 0) { // 0 禁止登录
				return this.$message.error(this.sysCfg.webtool_close_msg || '系统维护暂不支持使用')
			}
			if(this.currentMode == 1) {
				this.showSlide = true
			} else {
				this.handleLogin()
			}
		},
		handleLogin() {
			let params = {}
			let loginType = ''
			if (this.currentMode == 1) {
				if (this.isSubAccount) {
					params = { username: this.mobile, password: Md5(this.password) }
					loginType = 'subLogin'
				} else {
					params = { iso: "cn", mobile: this.mobile, password: Md5(this.password), brand: "web" }
					loginType = 'login'
				}
			} else {
				params = { iso: "cn", mobile: this.mobile, captcha: this.captcha, brand: "web" }
				loginType = 'codeLogin'
			}
			this.isLoading = true
			this.$store
                .dispatch("user/login", {
					params: {...params},
					type: loginType
				})
                .then((res) => {
					this.isLoading = false
                    this.$message.success('登录成功')
					setTimeout(() => {
						this.$router.replace(`/dashboard`)
					}, 1000)
                }).catch((err) => {
					this.isLoading = false
				})
		}
	}
}
</script>
<style lang="scss" scoped>
.tabs {
	margin-bottom: 30px;
	font-weight: 600;
	&-item {
		padding: 10px;
		&:nth-child(1) {
			margin-right: 20px;
		}
		&.active {
			position: relative;
			&:after {
				content: '';
				position: absolute;
				bottom: 0;
				left: 50%;
				width: 30px;
				height:4px;
				margin-left: -15px;
				border-radius: 6px;
				background: var(--main-bg-color);
			}
		}
	}
	
}
.form {
	.form-item {
		::v-deep .el-input__inner {
			color: #222222;
			font-size: 16px;
		}
		::v-deep .el-link {
			display: inline-flex;
			flex: none;
		}
		::v-deep .el-link--inner {
			font-size: 13px;
			text-align: right;
		}
		::v-deep .el-checkbox {
			display: flex;
			align-items: baseline;
			white-space: wrap;
		}
		::v-deep .el-checkbox__label {
			color: #333;
			display: inline-grid;
			// white-space: pre-line;
			// word-wrap: break-word;
			// line-height: 20px;
		}
		.login-btn {
			width: 100%;
			font-weight: bold;
			font-size: 16px;
		}
	}
}
</style>